import * as React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/login-page";
import LeaderBoardPage from "./pages/leaderboard-page";
import RequireAuth from "./components/RequireAuth";
import ErrorPage from "./pages/error-page";

const Navigation = () => {
  return (
    <Routes>
      <Route>
        <Route path="/:id" element={<LeaderBoardPage />} />
        <Route path="*" element={<ErrorPage />} />
        {/* <Route
          path="/protected"
          element={
            <RequireAuth>
              <LeaderBoardPage />
            </RequireAuth>
          }
        /> */}
      </Route>
    </Routes>
  );
};

export default Navigation;
